import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import { SearchConfigureButton } from "./search-configure-button";

export const SearchInputField = ({
  query,
  fetching,
  semanticLevel,
  onChange,
  onClear,
  onSemanticChange,
  onApply,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        onApply();
      }}
    >
      <TextField
        autoFocus
        fullWidth
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SvgIcon fontSize="small">
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </SvgIcon>
              </InputAdornment>
            ),
            endAdornment: fetching ? (
              <InputAdornment position="end">
                <CircularProgress size={16} />
              </InputAdornment>
            ) : query ? (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={onClear}
                  edge="end"
                  sx={{
                    width: 20,
                    height: 20,
                    bgcolor: "action.selected",
                    "&:hover": { bgcolor: "action.focus" },
                  }}
                >
                  <SvgIcon sx={{ fontSize: "0.7rem" }}>
                    <FontAwesomeIcon icon={faXmark} />
                  </SvgIcon>
                </IconButton>
              </InputAdornment>
            ) : null,
          },
        }}
        label={t("search.inputLabel")}
        onChange={onChange}
        placeholder={t("search.inputPlaceholder")}
        value={query}
      />

      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
        <Typography
          variant="caption"
          color="textSecondary"
          sx={{ fontStyle: "italic" }}
        >
          {t("search.tip")}
        </Typography>
        <SearchConfigureButton
          semanticLevel={semanticLevel}
          query={query}
          onSemanticChange={onSemanticChange}
          onApply={onApply}
        />
      </Box>
    </Box>
  );
};

SearchInputField.propTypes = {
  query: PropTypes.string.isRequired,
  fetching: PropTypes.bool,
  semanticLevel: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onSemanticChange: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
};
